import React, { useState } from 'react';
import { PropTypes } from 'prop-types';

import { TopButtonsWrapper } from '../../../styles';
import { Table, Download } from '../../../elements';

import {
  TABLE_COLUMNS, COLUMNS, FILE_NAME, TITLE,
} from './constants';
import { useRecordsList } from './hooks';
import { AggregatedInfo } from '../../../elements/Table/styles';

const RecordsListTable = ({ recordId, rerender }) => {
  const [data, loading] = useRecordsList(recordId, rerender);
  const [selected, updateSelected] = useState([]);
  const totalWeight = data.receptaclesInformation ? data.receptaclesInformation.reduce((sum, item) => sum + item.receptaclesWeight, 0) : 0;
  const totalCount = data.receptaclesInformation ? data.receptaclesInformation.reduce((sum, item) => sum + item.receptaclesNumber, 0) : 0;
  const fileName = `${FILE_NAME}_${recordId}_${data.operatorCode}_${data.carrierCode}`;
  const updateSelectedHandler = (newSelected) => {
    updateSelected(newSelected);
  };

  return (
    <>
      <AggregatedInfo>
        {/* eslint-disable-next-line */}
        <h4> Invoice Number: { recordId } </h4>
        {/* eslint-disable-next-line */}
        <h4> Operator: { data.operatorCode } </h4>
        {/* eslint-disable-next-line */}
        <h4>  Carrier: { data.carrierCode } </h4>
      </AggregatedInfo>
      <TopButtonsWrapper>
        <Download columns={COLUMNS} fileName={fileName} title={TITLE} items={data.receptaclesInformation ? data.receptaclesInformation : []} selected={selected} fontSize={6} />
      </TopButtonsWrapper>
      <Table
        className="InvoiceInformationList"
        columns={TABLE_COLUMNS}
        data={data.receptaclesInformation ? data.receptaclesInformation : []}
        loading={loading}
        onSelect={updateSelectedHandler}
        noActions
      />
      <AggregatedInfo>
        {/* eslint-disable-next-line */}
        <h4> Total Invoice Weight: { totalWeight } </h4>
        {/* eslint-disable-next-line */}
        <h4> Total Number of Receptacles for Invoice: { totalCount } </h4>
      </AggregatedInfo>
    </>
  );
};

RecordsListTable.propTypes = {
  requestId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

export default RecordsListTable;
